import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearUserFullInfo, clearUserHashCode } from "../../../actions/user";
import { useHistory } from "react-router";

export default function Logout() {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(clearUserHashCode());
    dispatch(clearUserFullInfo());
    localStorage.removeItem("token");
    history.replace("/");
  }, []);
  return null;
}
